module.exports = __webpack_public_path__ + "img/church.418e18c7.jpg";